module.exports = __webpack_public_path__ + "angular-locale_sv.js";


//////////////////
// WEBPACK FOOTER
// ./~/angular-i18n/angular-locale_sv.js
// module id = 546
// module chunks = 2